import { render, staticRenderFns } from "./AppSkeletonList.vue?vue&type=template&id=50d06724&scoped=true"
import script from "./AppSkeletonList.vue?vue&type=script&lang=js"
export * from "./AppSkeletonList.vue?vue&type=script&lang=js"
import style0 from "./AppSkeletonList.vue?vue&type=style&index=0&id=50d06724&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50d06724",
  null
  
)

export default component.exports